import { render, staticRenderFns } from "./careManage.vue?vue&type=template&id=284ab6bd&scoped=true"
import script from "./careManage.vue?vue&type=script&lang=js"
export * from "./careManage.vue?vue&type=script&lang=js"
import style0 from "./careManage.vue?vue&type=style&index=0&id=284ab6bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284ab6bd",
  null
  
)

export default component.exports